module.exports = __webpack_public_path__ + "static/media/chevron-square-right.9d03b4bf.svg";